import { addDays, startOfDay } from "date-fns";
import {
  EMPTY_ANALYTICS_FILTERS,
  type AnalyticsDailyStatsRequest,
  type AnalyticsDateRange,
  type AnalyticsFilters,
} from "@/features/analytics/types";

export const cloneAnalyticsFilters = (
  filters: AnalyticsFilters,
): AnalyticsFilters => {
  return {
    country: [...filters.country],
    region: [...filters.region],
    city: [...filters.city],
    platform: [...filters.platform],
    deviceType: [...filters.deviceType],
    channelId: [...filters.channelId],
    campaignUuid: [...filters.campaignUuid],
    kind: [...filters.kind],
    categories: [...filters.categories],
    tags: [...filters.tags],
  };
};

export const createEmptyAnalyticsFilters = (): AnalyticsFilters => {
  return cloneAnalyticsFilters(EMPTY_ANALYTICS_FILTERS);
};

export const createDailyStatsRequestForRange = (
  range: AnalyticsDateRange,
  filters: AnalyticsFilters,
): AnalyticsDailyStatsRequest => {
  const from = startOfDay(range.startDate);
  const to = addDays(startOfDay(range.endDate), 1);

  const request: AnalyticsDailyStatsRequest = {
    createdAt: {
      from: from.toISOString(),
      to: to.toISOString(),
    },
  };

  if (filters.country.length > 0) {
    request.country = [...filters.country];
  }

  if (filters.region.length > 0) {
    request.region = [...filters.region];
  }

  if (filters.city.length > 0) {
    request.city = [...filters.city];
  }

  if (filters.platform.length > 0) {
    request.platform = [...filters.platform];
  }

  if (filters.deviceType.length > 0) {
    request.deviceType = [...filters.deviceType];
  }

  if (filters.channelId.length > 0) {
    request.channelId = [...filters.channelId];
  }

  if (filters.campaignUuid.length > 0) {
    request.campaignUuid = [...filters.campaignUuid];
  }

  if (filters.kind.length > 0) {
    request.kind = [...filters.kind];
  }

  if (filters.categories.length > 0) {
    request.categories = [...filters.categories];
  }

  return request;
};

export const countActiveAnalyticsFilters = (
  filters: AnalyticsFilters,
): number => {
  return Object.values(filters).reduce((count, items) => {
    return items.length > 0 ? count + 1 : count;
  }, 0);
};

export const getAnalyticsResultsLabel = (resultsCount: number): string => {
  return resultsCount > 0
    ? `Showing 1 - ${resultsCount} of ${resultsCount} results`
    : "Showing 0 of 0 results";
};
